import globals from '../../../../styles/globals';

export default (theme) => ({
    ...globals(theme),
    link: {
        display: 'flex'
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20
    }
});
